module.exports = __webpack_public_path__ + "img/poster1.8b1d7d17.png";